// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IPoolAddressesProvider https://etherscan.io/address/0x2f39d218133AFaB8F2B819B1066c7E434Ad94E9e
export const POOL_ADDRESSES_PROVIDER = '0x2f39d218133AFaB8F2B819B1066c7E434Ad94E9e';

// IPool https://etherscan.io/address/0x87870Bca3F3fD6335C3F4ce8392D69350B4fA4E2
export const POOL = '0x87870Bca3F3fD6335C3F4ce8392D69350B4fA4E2';

// IPoolConfigurator https://etherscan.io/address/0x64b761D848206f447Fe2dd461b0c635Ec39EbB27
export const POOL_CONFIGURATOR = '0x64b761D848206f447Fe2dd461b0c635Ec39EbB27';

// IAaveOracle https://etherscan.io/address/0x54586bE62E3c3580375aE3723C145253060Ca0C2
export const ORACLE = '0x54586bE62E3c3580375aE3723C145253060Ca0C2';

// https://etherscan.io/address/0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A
export const ACL_ADMIN = '0x5300A1a15135EA4dc7aD5a167152C01EFc9b192A';

// IACLManager https://etherscan.io/address/0xc2aaCf6553D20d1e9d78E365AAba8032af9c85b0
export const ACL_MANAGER = '0xc2aaCf6553D20d1e9d78E365AAba8032af9c85b0';

// IPoolDataProvider https://etherscan.io/address/0x0a16f2FCC0D44FaE41cc54e079281D84A363bECD
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x0a16f2FCC0D44FaE41cc54e079281D84A363bECD';

// https://etherscan.io/address/0x8147b99DF7672A21809c9093E6F6CE1a60F119Bd
export const POOL_IMPL = '0x8147b99DF7672A21809c9093E6F6CE1a60F119Bd';

// https://etherscan.io/address/0x6fDdde45f777a4E461B0721a578b169b44579623
export const POOL_CONFIGURATOR_IMPL = '0x6fDdde45f777a4E461B0721a578b169b44579623';

// https://etherscan.io/address/0x8164Cc65827dcFe994AB23944CBC90e0aa80bFcb
export const DEFAULT_INCENTIVES_CONTROLLER = '0x8164Cc65827dcFe994AB23944CBC90e0aa80bFcb';

// https://etherscan.io/address/0x223d844fc4B006D67c0cDbd39371A9F73f69d974
export const EMISSION_MANAGER = '0x223d844fc4B006D67c0cDbd39371A9F73f69d974';

// ICollector https://etherscan.io/address/0x464C71f6c2F760DdA6093dCB91C24c39e5d6e18c
export const COLLECTOR = '0x464C71f6c2F760DdA6093dCB91C24c39e5d6e18c';

// https://etherscan.io/address/0xadC45Df3cf1584624C97338BEF33363BF5b97AdA
export const DEFAULT_A_TOKEN_IMPL = '0xadC45Df3cf1584624C97338BEF33363BF5b97AdA';

// https://etherscan.io/address/0xb27C52c7f84819e3157993489741cB60786aE330
export const DEFAULT_VARIABLE_DEBT_TOKEN_IMPL = '0xb27C52c7f84819e3157993489741cB60786aE330';

// https://etherscan.io/address/0xFCE597866Ffaf617EFdcA1C1Ad50eBCB16B5171E
export const RISK_STEWARD = '0xFCE597866Ffaf617EFdcA1C1Ad50eBCB16B5171E';

// https://etherscan.io/address/0xd7852E139a7097E119623de0751AE53a61efb442
export const DEBT_SWAP_ADAPTER = '0xd7852E139a7097E119623de0751AE53a61efb442';

// https://etherscan.io/address/0x21714092D90c7265F52fdfDae068EC11a23C6248
export const DELEGATION_AWARE_A_TOKEN_IMPL_REV_1 = '0x21714092D90c7265F52fdfDae068EC11a23C6248';

// https://etherscan.io/address/0x19A109d0dCB1268729341732Ac146D4A74c7034f
export const CONFIG_ENGINE = '0x19A109d0dCB1268729341732Ac146D4A74c7034f';

// https://etherscan.io/address/0xbaA999AC55EAce41CcAE355c77809e68Bb345170
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0xbaA999AC55EAce41CcAE355c77809e68Bb345170';

// https://etherscan.io/address/0x35bb522b102326ea3F1141661dF4626C87000e3E
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x35bb522b102326ea3F1141661dF4626C87000e3E';

// https://etherscan.io/address/0x411D79b8cC43384FDE66CaBf9b6a17180c842511
export const LEGACY_STATIC_A_TOKEN_FACTORY = '0x411D79b8cC43384FDE66CaBf9b6a17180c842511';

// https://etherscan.io/address/0xADC0A53095A0af87F3aa29FE0715B5c28016364e
export const SWAP_COLLATERAL_ADAPTER = '0xADC0A53095A0af87F3aa29FE0715B5c28016364e';

// https://etherscan.io/address/0xe3dFf4052F0bF6134ACb73bEaE8fe2317d71F047
export const UI_INCENTIVE_DATA_PROVIDER = '0xe3dFf4052F0bF6134ACb73bEaE8fe2317d71F047';

// https://etherscan.io/address/0x56b7A1012765C285afAC8b8F25C69Bf10ccfE978
export const UI_POOL_DATA_PROVIDER = '0x56b7A1012765C285afAC8b8F25C69Bf10ccfE978';

// https://etherscan.io/address/0xC7be5307ba715ce89b152f3Df0658295b3dbA8E2
export const WALLET_BALANCE_PROVIDER = '0xC7be5307ba715ce89b152f3Df0658295b3dbA8E2';

// https://etherscan.io/address/0xd01607c3C5eCABa394D8be377a08590149325722
export const WETH_GATEWAY = '0xd01607c3C5eCABa394D8be377a08590149325722';

// https://etherscan.io/address/0x78F8Bd884C3D738B74B420540659c82f392820e0
export const WITHDRAW_SWAP_ADAPTER = '0x78F8Bd884C3D738B74B420540659c82f392820e0';

// https://etherscan.io/address/0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034
export const SAVINGS_DAI_TOKEN_WRAPPER = '0xE28E2c8d240dd5eBd0adcab86fbD79df7a052034';

// https://etherscan.io/address/0xCb0b5cA20b6C5C02A9A3B2cE433650768eD2974F
export const STATA_FACTORY = '0xCb0b5cA20b6C5C02A9A3B2cE433650768eD2974F';

// https://etherscan.io/address/0x5513224daaEABCa31af5280727878d52097afA05
export const GHO_DIRECT_MINTER = '0x5513224daaEABCa31af5280727878d52097afA05';

// https://etherscan.io/address/0x31a0Ba3C2242a095dBF58A7C53751eCBd27dBA9b
export const DUST_BIN = '0x31a0Ba3C2242a095dBF58A7C53751eCBd27dBA9b';

// https://etherscan.io/address/0xf00E2de0E78DFf055A92AD4719a179CE275b6Ef7
export const CLINIC_STEWARD = '0xf00E2de0E78DFf055A92AD4719a179CE275b6Ef7';

// https://etherscan.io/address/0x8b493f416F5F7933cC146b1899c069F2361cad60
export const SVR_STEWARD = '0x8b493f416F5F7933cC146b1899c069F2361cad60';

// https://etherscan.io/address/0x22aC12a6937BBBC0a301AF9154d08EaD95673122
export const POOL_EXPOSURE_STEWARD = '0x22aC12a6937BBBC0a301AF9154d08EaD95673122';

// https://etherscan.io/address/0x7ABB46C690C52E919687D19ebF89C81A6136C1F2
export const EDGE_RISK_ORACLE = '0x7ABB46C690C52E919687D19ebF89C81A6136C1F2';

// https://etherscan.io/address/0xf721bE7AA57a987F3e4D05DAc6fcb5aBF9F7cE9A
export const EDGE_RISK_STEWARD_PENDLE_EMODE = '0xf721bE7AA57a987F3e4D05DAc6fcb5aBF9F7cE9A';

// https://etherscan.io/address/0x9F76954f5b55B4908d178f31C07F9537AC8328E7
export const EDGE_RISK_STEWARD_DISCOUNT_RATE = '0x9F76954f5b55B4908d178f31C07F9537AC8328E7';

// https://etherscan.io/address/0x83ab600cE8a61b43e1757b89C0589928f765c1C4
export const EDGE_INJECTOR_PENDLE_EMODE = '0x83ab600cE8a61b43e1757b89C0589928f765c1C4';

// https://etherscan.io/address/0x15885A83936EB943e98EeFFb91e9A49040d93993
export const EDGE_INJECTOR_DISCOUNT_RATE = '0x15885A83936EB943e98EeFFb91e9A49040d93993';

// https://etherscan.io/address/0x80CFd14236409107c220d1D0a3dE845b48fdcDfc
export const EDGE_RISK_STEWARD_RATES = '0x80CFd14236409107c220d1D0a3dE845b48fdcDfc';

// https://etherscan.io/address/0x74dc6321A338420238CBD77abA5fEa8679393A66
export const EDGE_INJECTOR_RATES = '0x74dc6321A338420238CBD77abA5fEa8679393A66';

// https://etherscan.io/address/0xb7D402138Cb01BfE97d95181C849379d6AD14d19
export const COLLECTOR_SWAP_STEWARD = '0xb7D402138Cb01BfE97d95181C849379d6AD14d19';

export const CHAIN_ID = 1;
export const ASSETS = {
  WETH: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
    A_TOKEN: '0x4d5F47FA6A74757f35C14fD3a6Ef8E3C9BC514E8',
    V_TOKEN: '0xeA51d7853EEFb32b6ee06b1C12E6dcCA88Be0fFE',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x5424384B256154046E9667dDFaaa5e550145215e',
    STATIC_A_TOKEN: '0x252231882FB38481497f3C767469106297c8d93b',
    STATA_TOKEN: '0x0bfc9d54Fc184518A81162F8fB99c2eACa081202',
  },
  wstETH: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    A_TOKEN: '0x0B925eD163218f6662a35e0f0371Ac234f9E9371',
    V_TOKEN: '0xC96113eED8cAB59cD8A66813bCB0cEb29F06D2e4',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xe1D97bF61901B075E9626c8A2340a7De385861Ef',
    STATIC_A_TOKEN: '0x322AA5F5Be95644d6c36544B6c5061F072D16DF5',
  },
  WBTC: {
    decimals: 8,
    id: 2,
    UNDERLYING: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    A_TOKEN: '0x5Ee5bf7ae06D1Be5997A1A72006FE6C607eC6DE8',
    V_TOKEN: '0x40aAbEf1aa8f0eEc637E0E7d92fbfFB2F26A8b7B',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xDaa4B74C6bAc4e25188e64ebc68DB5050b690cAc',
    STATIC_A_TOKEN: '0xB07E357cc262E92eee03D8B81464D596B258eA7a',
  },
  USDC: {
    decimals: 6,
    id: 3,
    UNDERLYING: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    A_TOKEN: '0x98C23E9d8f34FEFb1B7BD6a91B7FF122F4e16F5c',
    V_TOKEN: '0x72E95b8931767C79bA4EeE721354d6E99a61D004',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x3f73F03aa83B2A48ed27E964eD0fDb590332095B',
    STATIC_A_TOKEN: '0x73edDFa87C71ADdC275c2b9890f5c3a8480bC9E6',
    STATA_TOKEN: '0xD4fa2D31b7968E448877f69A96DE69f5de8cD23E',
  },
  DAI: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    A_TOKEN: '0x018008bfb33d285247A21d44E50697654f754e63',
    V_TOKEN: '0xcF8d0c70c850859266f5C338b38F9D663181C314',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x5c66322CA59bB61e867B28195576DbD8dA4b08dE',
    STATIC_A_TOKEN: '0xaf270C38fF895EA3f95Ed488CEACe2386F038249',
    STATA_TOKEN: '0x5caF5a86f39073637Ac7c8A7b5290871de80cb9b',
  },
  LINK: {
    decimals: 18,
    id: 5,
    UNDERLYING: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
    A_TOKEN: '0x5E8C8A7243651DB1384C0dDfDbE39761E8e7E51a',
    V_TOKEN: '0x4228F8895C7dDA20227F6a5c6751b8Ebf19a6ba8',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xC7e9b623ed51F033b32AE7f1282b1AD62C28C183',
    STATIC_A_TOKEN: '0x57bd8C73838d1781b4f6E0d5Cf89eb676488d3df',
  },
  AAVE: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
    A_TOKEN: '0xA700b4eB416Be35b2911fd5Dee80678ff64fF6C9',
    V_TOKEN: '0xBae535520Abd9f8C85E58929e0006A2c8B372F74',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xF02C1e2A3B77c1cacC72f72B44f7d0a4c62e4a85',
    STATIC_A_TOKEN: '0xFEB859A50f92C6D5ad7C9eF7C2c060D164B3280f',
  },
  cbETH: {
    decimals: 18,
    id: 7,
    UNDERLYING: '0xBe9895146f7AF43049ca1c1AE358B0541Ea49704',
    A_TOKEN: '0x977b6fc5dE62598B08C85AC8Cf2b745874E8b78c',
    V_TOKEN: '0x0c91bcA95b5FE69164cE583A2ec9429A569798Ed',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x889399C34461b25d70d43931e6cE9E40280E617B',
    STATIC_A_TOKEN: '0xe2a6863C8f043457B497667Ef3c43073e2D69089',
  },
  USDT: {
    decimals: 6,
    id: 8,
    UNDERLYING: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    A_TOKEN: '0x23878914EFE38d27C4D67Ab83ed1b93A74D4086a',
    V_TOKEN: '0x6df1C1E379bC5a00a7b4C6e67A203333772f45A8',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x260326c220E469358846b187eE53328303Efe19C',
    STATIC_A_TOKEN: '0x862c57d48becB45583AEbA3f489696D22466Ca1b',
    STATA_TOKEN: '0x7Bc3485026Ac48b6cf9BaF0A377477Fff5703Af8',
  },
  rETH: {
    decimals: 18,
    id: 9,
    UNDERLYING: '0xae78736Cd615f374D3085123A210448E74Fc6393',
    A_TOKEN: '0xCc9EE9483f662091a1de4795249E24aC0aC2630f',
    V_TOKEN: '0xae8593DD575FE29A9745056aA91C4b746eee62C8',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x6929706c42d637DF5Ebf7F0BcfF2aF47F84Ea69D',
    STATIC_A_TOKEN: '0x867Cf025B5dA438c4e215c60B59bBB3aFe896Fda',
  },
  LUSD: {
    decimals: 18,
    id: 10,
    UNDERLYING: '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
    A_TOKEN: '0x3Fe6a295459FAe07DF8A0ceCC36F37160FE86AA9',
    V_TOKEN: '0x33652e48e4B74D18520f11BfE58Edd2ED2cEc5A2',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xEbb721daf3DA9f1b3dcEc590cDf648137172d7CB',
    STATIC_A_TOKEN: '0xDBf5E36569798D1E39eE9d7B1c61A7409a74F23A',
  },
  CRV: {
    decimals: 18,
    id: 11,
    UNDERLYING: '0xD533a949740bb3306d119CC777fa900bA034cd52',
    A_TOKEN: '0x7B95Ec873268a6BFC6427e7a28e396Db9D0ebc65',
    V_TOKEN: '0x1b7D3F4b3c032a5AE656e30eeA4e8E1Ba376068F',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xCd627aA160A6fA45Eb793D19Ef54f5062F20f33f',
    STATIC_A_TOKEN: '0x149EE12310D499F701B6A5714eDAd2C832008fd2',
  },
  MKR: {
    decimals: 18,
    id: 12,
    UNDERLYING: '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2',
    A_TOKEN: '0x8A458A9dc9048e005d22849F470891b840296619',
    V_TOKEN: '0x6Efc73E54E41b27d2134fF9f98F15550f30DF9B1',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x44Bb2a64bAf94210B583338D3D97b1e8288Bd478',
  },
  SNX: {
    decimals: 18,
    id: 13,
    UNDERLYING: '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F',
    A_TOKEN: '0xC7B4c17861357B8ABB91F25581E7263E08DCB59c',
    V_TOKEN: '0x8d0de040e8aAd872eC3c33A3776dE9152D3c34ca',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xDC3EA94CD0AC27d9A86C180091e7f78C683d3699',
    STATIC_A_TOKEN: '0xaECEbdfE454d869A626cAb38226C52a1575D1866',
  },
  BAL: {
    decimals: 18,
    id: 14,
    UNDERLYING: '0xba100000625a3754423978a60c9317c58a424e3D',
    A_TOKEN: '0x2516E7B3F76294e03C42AA4c5b5b4DCE9C436fB8',
    V_TOKEN: '0x3D3efceb4Ff0966D34d9545D3A2fa2dcdBf451f2',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xdF2917806E30300537aEB49A7663062F4d1F2b5F',
  },
  UNI: {
    decimals: 18,
    id: 15,
    UNDERLYING: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
    A_TOKEN: '0xF6D2224916DDFbbab6e6bd0D1B7034f4Ae0CaB18',
    V_TOKEN: '0xF64178Ebd2E2719F2B1233bCb5Ef6DB4bCc4d09a',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x553303d460EE0afB37EdFf9bE42922D8FF63220e',
    STATIC_A_TOKEN: '0x78fb5E79D5cb59729D0cd72bEA7879aD2683454D',
  },
  LDO: {
    decimals: 18,
    id: 16,
    UNDERLYING: '0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32',
    A_TOKEN: '0x9A44fd41566876A39655f74971a3A6eA0a17a454',
    V_TOKEN: '0xc30808705C01289A3D306ca9CAB081Ba9114eC82',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xb01e6C9af83879B8e06a092f0DD94309c0D497E4',
    STATIC_A_TOKEN: '0x1eA6E1ba21601258401d0B9DB24eA0a07948458e',
  },
  ENS: {
    decimals: 18,
    id: 17,
    UNDERLYING: '0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72',
    A_TOKEN: '0x545bD6c032eFdde65A377A6719DEF2796C8E0f2e',
    V_TOKEN: '0xd180D7fdD4092f07428eFE801E17BC03576b3192',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x5C00128d4d1c2F4f652C267d7bcdD7aC99C16E16',
    STATIC_A_TOKEN: '0x2767C27Eeaf3566082E74b963B6A0f5c9a46C8a1',
  },
  ONE_INCH: {
    decimals: 18,
    id: 18,
    UNDERLYING: '0x111111111117dC0aa78b770fA6A738034120C302',
    A_TOKEN: '0x71Aef7b30728b9BB371578f36c5A1f1502a5723e',
    V_TOKEN: '0xA38fCa8c6Bf9BdA52E76EB78f08CaA3BE7c5A970',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xc929ad75B72593967DE83E7F7Cda0493458261D9',
    STATIC_A_TOKEN: '0xB490fF18e55b8881C9527FE7E358dd363780449F',
  },
  FRAX: {
    decimals: 18,
    id: 19,
    UNDERLYING: '0x853d955aCEf822Db058eb8505911ED77F175b99e',
    A_TOKEN: '0xd4e245848d6E1220DBE62e155d89fa327E43CB06',
    V_TOKEN: '0x88B8358F5BC87c2D7E116cCA5b65A9eEb2c5EA3F',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xeF50f8DC65402c3019586bc8725fCD0b99B8AAd7',
    STATIC_A_TOKEN: '0xEE66abD4D0f9908A48E08AE354B0f425De3e237E',
  },
  GHO: {
    decimals: 18,
    id: 20,
    UNDERLYING: '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
    A_TOKEN: '0x00907f9921424583e7ffBfEdf84F92B7B2Be4977',
    V_TOKEN: '0x786dBff3f1292ae8F92ea68Cf93c30b34B1ed04B',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xD110cac5d8682A3b045D5524a9903E031d70FCCd',
    STATIC_A_TOKEN: '0x048459E4fb3402e58d8900aF7283Ad574B91d742',
  },
  RPL: {
    decimals: 18,
    id: 21,
    UNDERLYING: '0xD33526068D116cE69F19A9ee46F0bd304F21A51f',
    A_TOKEN: '0xB76CF92076adBF1D9C39294FA8e7A67579FDe357',
    V_TOKEN: '0x8988ECA19D502fd8b9CCd03fA3bD20a6f599bc2A',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x4E155eD98aFE9034b7A5962f6C84c86d869daA9d',
    STATIC_A_TOKEN: '0x95EF7cb3494e65dA4926bA330dBf540a13afFD17',
    STATA_TOKEN: '0x91ad1f5443cF356010D2171D6D26B11C309c4b16',
  },
  sDAI: {
    decimals: 18,
    id: 22,
    UNDERLYING: '0x83F20F44975D03b1b09e64809B757c47f942BEeA',
    A_TOKEN: '0x4C612E3B15b96Ff9A6faED838F8d07d479a8dD4c',
    V_TOKEN: '0x8Db9D35e117d8b93C6Ca9b644b25BaD5d9908141',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xf83B85205241c3BCCA0a09D32FaE65c16e0CF236',
    STATIC_A_TOKEN: '0xFa7E3571786CE9489bBC58d9Cb8ecE8aAe6B56F3',
  },
  STG: {
    decimals: 18,
    id: 23,
    UNDERLYING: '0xAf5191B0De278C7286d6C7CC6ab6BB8A73bA2Cd6',
    A_TOKEN: '0x1bA9843bD4327c6c77011406dE5fA8749F7E3479',
    V_TOKEN: '0x655568bDd6168325EC7e58Bf39b21A856F906Dc2',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x7A9f34a0Aa917D438e9b6E630067062B7F8f6f3d',
  },
  KNC: {
    decimals: 18,
    id: 24,
    UNDERLYING: '0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202',
    A_TOKEN: '0x5b502e3796385E1e9755d7043B9C945C3aCCeC9C',
    V_TOKEN: '0x253127Ffc04981cEA8932F406710661c2f2c3fD2',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xf8fF43E991A81e6eC886a3D281A2C6cC19aE70Fc',
  },
  FXS: {
    decimals: 18,
    id: 25,
    UNDERLYING: '0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0',
    A_TOKEN: '0x82F9c5ad306BBa1AD0De49bB5FA6F01bf61085ef',
    V_TOKEN: '0x68e9f0aD4e6f8F5DB70F6923d4d6d5b225B83b16',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x6Ebc52C8C1089be9eB3945C4350B68B8E4C2233f',
  },
  crvUSD: {
    decimals: 18,
    id: 26,
    UNDERLYING: '0xf939E0A03FB07F59A73314E73794Be0E57ac1b4E',
    A_TOKEN: '0xb82fa9f31612989525992FCfBB09AB22Eff5c85A',
    V_TOKEN: '0x028f7886F3e937f8479efaD64f31B3fE1119857a',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x9Dc30dc58c72f5B669aEa01d02A2e4da194eE893',
    STATIC_A_TOKEN: '0x848107491E029AFDe0AC543779c7790382f15929',
  },
  PYUSD: {
    decimals: 6,
    id: 27,
    UNDERLYING: '0x6c3ea9036406852006290770BEdFcAbA0e23A0e8',
    A_TOKEN: '0x0C0d01AbF3e6aDfcA0989eBbA9d6e85dD58EaB1E',
    V_TOKEN: '0x57B67e4DE077085Fd0AF2174e9c14871BE664546',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x36964C0579D02E0a5AaAb89E24Cf8d7CDF3549EE',
    STATIC_A_TOKEN: '0x00F2a835758B33f3aC53516Ebd69f3dc77B0D152',
    STATA_TOKEN: '0xb51EDdDD8c47856D81C8681EA71404Cec93E92c6',
  },
  weETH: {
    decimals: 18,
    id: 28,
    UNDERLYING: '0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee',
    A_TOKEN: '0xBdfa7b7893081B35Fb54027489e2Bc7A38275129',
    V_TOKEN: '0x77ad9BF13a52517AD698D65913e8D381300c8Bf3',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x87625393534d5C102cADB66D37201dF24cc26d4C',
    STATIC_A_TOKEN: '0x867b0CDC4B39a19945E616c29639b0390b39db3B',
  },
  osETH: {
    decimals: 18,
    id: 29,
    UNDERLYING: '0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38',
    A_TOKEN: '0x927709711794F3De5DdBF1D176bEE2D55Ba13c21',
    V_TOKEN: '0x8838eefF2af391863E1Bb8b1dF563F86743a8470',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x2b86D519eF34f8Adfc9349CDeA17c09Aa9dB60E2',
    STATIC_A_TOKEN: '0xE5248968166206d14ab57345971E32facD839aDA',
  },
  USDe: {
    decimals: 18,
    id: 30,
    UNDERLYING: '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
    A_TOKEN: '0x4F5923Fc5FD4a93352581b38B7cD26943012DECF',
    V_TOKEN: '0x015396E1F286289aE23a762088E863b3ec465145',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xC26D4a1c46d884cfF6dE9800B6aE7A8Cf48B4Ff8',
    STATIC_A_TOKEN: '0x46e5d6A33C8Bd8eD38F3c95991C78C9B2FF3bC99',
    STATA_TOKEN: '0x5F9D59db355b4A60501544637b00e94082cA575b',
  },
  ETHx: {
    decimals: 18,
    id: 31,
    UNDERLYING: '0xA35b1B31Ce002FBF2058D22F30f95D405200A15b',
    A_TOKEN: '0x1c0E06a0b1A4c160c17545FF2A951bfcA57C0002',
    V_TOKEN: '0x08a8Dc81AeA67F84745623aC6c72CDA3967aab8b',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xd7b163B671f8cE9379DF8Ff7F75fA72Ccec1841c',
    STATIC_A_TOKEN: '0x7CC6694CF75C18D488d16FB4bf3c71A3B31cc7FB',
  },
  sUSDe: {
    decimals: 18,
    id: 32,
    UNDERLYING: '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
    A_TOKEN: '0x4579a27aF00A62C0EB156349f31B345c08386419',
    V_TOKEN: '0xeFFDE9BFA8EC77c14C364055a200746d6e12BeD6',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x42bc86f2f08419280a99d8fbEa4672e7c30a86ec',
    STATIC_A_TOKEN: '0x54D612b000697bd8B0094889D7d6A92bA0Bf2DEa',
  },
  tBTC: {
    decimals: 18,
    id: 33,
    UNDERLYING: '0x18084fbA666a33d37592fA2633fD49a74DD93a88',
    A_TOKEN: '0x10Ac93971cdb1F5c778144084242374473c350Da',
    V_TOKEN: '0xAC50890a80A2731eb1eA2e9B4F29569CeB06D960',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xb41E773f507F7a7EA890b1afB7d2b660c30C8B0A',
  },
  cbBTC: {
    decimals: 8,
    id: 34,
    UNDERLYING: '0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf',
    A_TOKEN: '0x5c647cE0Ae10658ec44FA4E11A51c96e94efd1Dd',
    V_TOKEN: '0xeB284A70557EFe3591b9e6D9D720040E02c54a4d',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xb41E773f507F7a7EA890b1afB7d2b660c30C8B0A',
  },
  USDS: {
    decimals: 18,
    id: 35,
    UNDERLYING: '0xdC035D45d973E3EC169d2276DDab16f1e407384F',
    A_TOKEN: '0x32a6268f9Ba3642Dda7892aDd74f1D34469A4259',
    V_TOKEN: '0x490E0E6255bF65b43E2e02F7acB783c5e04572Ff',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x94C7FD62fd0506e71d8142E9D36687fC72A86B02',
    STATA_TOKEN: '0xb80B3215EA8183a064073f9892eb64236160a4dF',
  },
  rsETH: {
    decimals: 18,
    id: 36,
    UNDERLYING: '0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7',
    A_TOKEN: '0x2D62109243b87C4bA3EE7bA1D91B0dD0A074d7b1',
    V_TOKEN: '0x6De3E52A1B7294A34e271a508082b1Ff4a37E30e',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x7292C95A5f6A501a9c4B34f6393e221F2A0139c3',
  },
  LBTC: {
    decimals: 8,
    id: 37,
    UNDERLYING: '0x8236a87084f8B84306f72007F36F2618A5634494',
    A_TOKEN: '0x65906988ADEe75306021C417a1A3458040239602',
    V_TOKEN: '0x68aeB290C7727D899B47c56d1c96AEAC475cD0dD',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xf8c04B50499872A5B5137219DEc0F791f7f620D0',
  },
  eBTC: {
    decimals: 8,
    id: 38,
    UNDERLYING: '0x657e8C867D8B37dCC18fA4Caead9C45EB088C642',
    A_TOKEN: '0x5fefd7069a7D91d01f269DADE14526CCF3487810',
    V_TOKEN: '0x47eD0509e64615c0d5C6d39AF1B38D02Bc9fE58f',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x03bB418e89B75407585f8198178f253DA3216218',
  },
  RLUSD: {
    decimals: 18,
    id: 39,
    UNDERLYING: '0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD',
    A_TOKEN: '0xFa82580c16A31D0c1bC632A36F82e83EfEF3Eec0',
    V_TOKEN: '0xBdFe7aD7976d5d7E0965ea83a81Ca1bCfF7e84a9',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xf0eaC18E908B34770FDEe46d069c846bDa866759',
    STATA_TOKEN: '0x6A1792a91C08e9f0bFe7a990871B786643237f0F',
  },
  PT_eUSDE_29MAY2025: {
    decimals: 18,
    id: 40,
    UNDERLYING: '0x50D2C7992b802Eef16c04FeADAB310f31866a545',
    A_TOKEN: '0x4B0821e768Ed9039a70eD1E80E15E76a5bE5Df5F',
    V_TOKEN: '0x3c20fbFD32243Dd9899301C84bCe17413EeE0A0C',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x5292AB3292D076271f853Ed8e05e61cc02F0A2C6',
  },
  PT_sUSDE_31JUL2025: {
    decimals: 18,
    id: 41,
    UNDERLYING: '0x3b3fB9C57858EF816833dC91565EFcd85D96f634',
    A_TOKEN: '0xDE6eF6CB4aBd3A473ffC2942eEf5D84536F8E864',
    V_TOKEN: '0x8C6FeaF5d58BA1A6541F9c4aF685f62bFCBaC3b1',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x759B9B72700A129CD7AD8e53F9c99cb48Fd57105',
  },
  USDtb: {
    decimals: 18,
    id: 42,
    UNDERLYING: '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
    A_TOKEN: '0xEc4ef66D4fCeEba34aBB4dE69dB391Bc5476ccc8',
    V_TOKEN: '0xeA85a065F87FE28Aa8Fbf0D6C7deC472b106252C',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x88025072A7dB6Db5e54E46d43850bb44CA93D6C0',
    STATA_TOKEN: '0x2FE4dC166ADbc0B39EdB47F4324F00A7374daBF7',
  },
  PT_USDe_31JUL2025: {
    decimals: 18,
    id: 43,
    UNDERLYING: '0x917459337CaAC939D41d7493B3999f571D20D667',
    A_TOKEN: '0x312ffC57778CEfa11989733e6E08143E7E229c1c',
    V_TOKEN: '0xd90DA2Df915B87fE1621A7F2201FbF4ff2cCA031',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x6b99e86B48Fee533B7Bee602e7959f024051Eca0',
  },
  PT_eUSDE_14AUG2025: {
    decimals: 18,
    id: 44,
    UNDERLYING: '0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617',
    A_TOKEN: '0x2eDff5AF94334fBd7C38ae318edf1c40e072b73B',
    V_TOKEN: '0x22517fE16DEd08e52E7EA3423A2EA4995b1f1731',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x03f9bA9A897241985c1f12bCe97fAC1B0bd4a7A7',
  },
  eUSDe: {
    decimals: 18,
    id: 45,
    UNDERLYING: '0x90D2af7d622ca3141efA4d8f1F24d86E5974Cc8F',
    A_TOKEN: '0x5F9190496e0DFC831C3bd307978de4a245E2F5cD',
    V_TOKEN: '0x48351fCc9536dA440AE9471220F6dC921b0eB703',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xc7Ad695ac0ae38Ae308640897E51468977A862a2',
  },
  FBTC: {
    decimals: 8,
    id: 46,
    UNDERLYING: '0xC96dE26018A54D51c097160568752c4E3BD6C364',
    A_TOKEN: '0xcCA43ceF272c30415866914351fdfc3E881bb7c2',
    V_TOKEN: '0x4A35FD7F93324Cc48bc12190D3F37493437b1Eff',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xb41E773f507F7a7EA890b1afB7d2b660c30C8B0A',
  },
  EURC: {
    decimals: 6,
    id: 47,
    UNDERLYING: '0x1aBaEA1f7C830bD89Acc67eC4af516284b1bC33c',
    A_TOKEN: '0xAA6e91C82942aeAE040303Bf96c15a6dBcB82CA0',
    V_TOKEN: '0x6c82c66622Eb360FC973D3F492f9D8E9eA538b08',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xa6aB031A4d189B24628EC9Eb155F0a0f1A0E55a3',
  },
  PT_sUSDE_25SEP2025: {
    decimals: 18,
    id: 48,
    UNDERLYING: '0x9F56094C450763769BA0EA9Fe2876070c0fD5F77',
    A_TOKEN: '0x5f4a0873a3A02f7C0CB0e13a1d4362a1AD90e751',
    V_TOKEN: '0xc9AD8Dd111e6384128146467aAf92B81EC422848',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x7585693910f39df4959912B27D09EAEef06C1a93',
  },
  PT_USDe_25SEP2025: {
    decimals: 18,
    id: 49,
    UNDERLYING: '0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a',
    A_TOKEN: '0x38A5357Ce55c81add62aBc84Fb32981e2626ADEf',
    V_TOKEN: '0x0D8486E1CAbf3C9407B3DdA0cfc4d9C3101fB683',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x8B17C02d22EE7D6B8D6829ceB710A458de41E84a',
  },
  tETH: {
    decimals: 18,
    id: 50,
    UNDERLYING: '0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8',
    A_TOKEN: '0x481a2acf3A72ffDc602A9541896Ca1DB87f86cf7',
    V_TOKEN: '0x7EC9Afe70f8FD603282eBAcbc9058A83623E2899',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x85968026294b8f8Fb86d6bF3Cda079f9376aD05A',
  },
  ezETH: {
    decimals: 18,
    id: 51,
    UNDERLYING: '0xbf5495Efe5DB9ce00f80364C8B423567e58d2110',
    A_TOKEN: '0x4E2a4d9B3DF7Aae73b418Bd39F3af9e148E3F479',
    V_TOKEN: '0x730318dB7b830d324fC3fEDDB1d212Ec64bD3141',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xF3d49021fF3bbBFDfC1992A4b09E5D1d141D044C',
  },
  XAUt: {
    decimals: 6,
    id: 52,
    UNDERLYING: '0x68749665FF8D2d112Fa859AA293F07A622782F38',
    A_TOKEN: '0x8A2b6f94Ff3A89a03E8c02Ee92b55aF90c9454A2',
    V_TOKEN: '0xa665bB258D2a732C170dFD505924214c0b1AC74F',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x214eD9Da11D2fbe465a6fc601a91E62EbEc1a0D6',
  },
  PT_sUSDE_27NOV2025: {
    decimals: 18,
    id: 53,
    UNDERLYING: '0xe6A934089BBEe34F832060CE98848359883749B3',
    A_TOKEN: '0x285866acB0d60105B4Ed350a463361c2d9afA0E2',
    V_TOKEN: '0x690Df181701C11C53EA33bBF303C25834b66bD14',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x8B8B73598a2c4b1de6d3b075618434CfC4826632',
  },
  PT_USDe_27NOV2025: {
    decimals: 18,
    id: 54,
    UNDERLYING: '0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7',
    A_TOKEN: '0x38C503a438185cDE29b5cF4dC1442FD6F074F1cc',
    V_TOKEN: '0x2CE7e7b238985A8aD3863De03F200B245B0c1216',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x6A196A7B498C4EFBFEfB55364106EC80CceF0C3F',
  },
  PT_USDe_5FEB2026: {
    decimals: 18,
    id: 55,
    UNDERLYING: '0x1F84a51296691320478c98b8d77f2Bbd17D34350',
    A_TOKEN: '0xE728577e9a1Fe7032bc309B4541F58f45443866e',
    V_TOKEN: '0x9D244A99801dc05cbC04183769c17056B8A1Ad53',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xc35D319FA5FEc2BBE0eB4d0a826465b60f821F81',
  },
  PT_sUSDE_5FEB2026: {
    decimals: 18,
    id: 56,
    UNDERLYING: '0xE8483517077afa11A9B07f849cee2552f040d7b2',
    A_TOKEN: '0xbe54767735fB7Acca2aa7E2d209a6f705073536D',
    V_TOKEN: '0xA803414f84fCEF00e745bE7CC2A315908927f15D',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x4e89f87F24C13819bBDDb56f99b38746C91677D8',
  },
  mUSD: {
    decimals: 6,
    id: 57,
    UNDERLYING: '0xacA92E438df0B2401fF60dA7E4337B687a2435DA',
    A_TOKEN: '0xAa0200d169fF3ba9385c12E073c5d1d30434AE7b',
    V_TOKEN: '0xE35e6A0D3AbC28289f5d4C2d262a133Df936b98D',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x8adb5187695F773513dEC4b569d21db0341931dA',
  },
  syrupUSDT: {
    decimals: 6,
    id: 58,
    UNDERLYING: '0x356B8d89c1e1239Cbbb9dE4815c39A1474d5BA7D',
    A_TOKEN: '0x24Ab03a9a5Bc2C49E5523e8d915A3536ac38B91D',
    V_TOKEN: '0xAEf73b04654931B94920a3D7AE62032b79fB6d0c',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x982aC260B5a4e5bCAb6A437e79168390cFbDe70D',
  },
  USDG: {
    decimals: 6,
    id: 59,
    UNDERLYING: '0xe343167631d89B6Ffc58B88d6b7fB0228795491D',
    A_TOKEN: '0x7c0477d085ECb607CF8429f3eC91Ae5E1e460F4F',
    V_TOKEN: '0x4f97B950a30321c181E974971E156E19fAD184A3',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xF29b1e3b68Fd59DD0a413811fD5d0AbaE653216d',
  },
  PT_USDe_7MAY2026: {
    decimals: 18,
    id: 60,
    UNDERLYING: '0xAeBf0Bb9f57E89260d57f31AF34eB58657d96Ce0',
    A_TOKEN: '0xE036478Da9A7ed89b56FE39A06e1FC1a4b38D4Ea',
    V_TOKEN: '0x04142fc546D59838852873bba5C8827601A13FC8',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0x0a72df02CE3E4185b6CEDf561f0AE651E9BeE235',
  },
  PT_sUSDE_7MAY2026: {
    decimals: 18,
    id: 61,
    UNDERLYING: '0x3de0ff76E8b528C092d47b9DaC775931cef80F49',
    A_TOKEN: '0x81b76ff3FeD28BA0B4a5D4c76Bd5C13Bd0641d86',
    V_TOKEN: '0x762Edb8D79b97487F82093f85059e42EeEf61E9e',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xa0dc0249c32fa79e8B9b17c735908a60b1141B40',
  },
  PT_srUSDe_2APR2026: {
    decimals: 18,
    id: 62,
    UNDERLYING: '0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375',
    A_TOKEN: '0x1241ec22C9BdF16BA1Eb636F2a8de7e28A4343Cf',
    V_TOKEN: '0xacD3d3FaCeA0424984F662827B988f4581a3cE31',
    INTEREST_RATE_STRATEGY: '0x9ec6F08190DeA04A54f8Afc53Db96134e5E3FdFB',
    ORACLE: '0xB539C6C0fc36ff1572B13ACec343B854937db576',
  },
} as const;
export const E_MODES = {
  '1': {
    label: 'WETH,wstETH,cbETH,rETH,weETH,osETH,ETHx / WETH',
    collateralBitmap: '2952790659',
    collateralAssets: [
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
      '0xBe9895146f7AF43049ca1c1AE358B0541Ea49704',
      '0xae78736Cd615f374D3085123A210448E74Fc6393',
      '0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee',
      '0xf1C9acDc66974dFB6dEcB12aA385b9cD01190E38',
      '0xA35b1B31Ce002FBF2058D22F30f95D405200A15b',
    ],
    borrowableBitmap: '1',
    borrowableAssets: ['0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '2': {
    label: 'USDe,sUSDe / USDC,USDT',
    collateralBitmap: '5368709120',
    collateralAssets: [
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
    ],
    borrowableBitmap: '264',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10400,
  },
  '3': {
    label: 'rsETH / WETH,wstETH,ETHx',
    collateralBitmap: '68719476736',
    collateralAssets: ['0xA1290d69c65A6Fe4DF752f95823fae25cB99e5A7'],
    borrowableBitmap: '2147483651',
    borrowableAssets: [
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
      '0xA35b1B31Ce002FBF2058D22F30f95D405200A15b',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '4': {
    label: 'LBTC / WBTC',
    collateralBitmap: '137438953472',
    collateralAssets: ['0x8236a87084f8B84306f72007F36F2618A5634494'],
    borrowableBitmap: '4',
    borrowableAssets: ['0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8400,
    liquidationThreshold: 8600,
    liquidationBonus: 10300,
  },
  '5': {
    label: 'LBTC / cbBTC',
    collateralBitmap: '137438953472',
    collateralAssets: ['0x8236a87084f8B84306f72007F36F2618A5634494'],
    borrowableBitmap: '17179869184',
    borrowableAssets: ['0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8400,
    liquidationThreshold: 8600,
    liquidationBonus: 10300,
  },
  '6': {
    label: 'LBTC / tBTC',
    collateralBitmap: '137438953472',
    collateralAssets: ['0x8236a87084f8B84306f72007F36F2618A5634494'],
    borrowableBitmap: '8589934592',
    borrowableAssets: ['0x18084fbA666a33d37592fA2633fD49a74DD93a88'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8400,
    liquidationThreshold: 8600,
    liquidationBonus: 10300,
  },
  '7': {
    label: 'eBTC / WBTC',
    collateralBitmap: '274877906944',
    collateralAssets: ['0x657e8C867D8B37dCC18fA4Caead9C45EB088C642'],
    borrowableBitmap: '4',
    borrowableAssets: ['0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8300,
    liquidationThreshold: 8500,
    liquidationBonus: 10300,
  },
  '8': {
    label: 'sUSDe,PT_sUSDE_31JUL2025 / USDC,USDT',
    collateralBitmap: '2203318222848',
    collateralAssets: [
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
      '0x3b3fB9C57858EF816833dC91565EFcd85D96f634',
    ],
    borrowableBitmap: '264',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10300,
  },
  '9': {
    label: 'PT_eUSDE_29MAY2025,eUSDe / USDC,USDT',
    collateralBitmap: '36283883716608',
    collateralAssets: [
      '0x50D2C7992b802Eef16c04FeADAB310f31866a545',
      '0x90D2af7d622ca3141efA4d8f1F24d86E5974Cc8F',
    ],
    borrowableBitmap: '264',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9100,
    liquidationThreshold: 9300,
    liquidationBonus: 10210,
  },
  '10': {
    label: 'USDe,PT_USDe_31JUL2025 / USDC,USDT',
    collateralBitmap: '8797166764032',
    collateralAssets: [
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0x917459337CaAC939D41d7493B3999f571D20D667',
    ],
    borrowableBitmap: '264',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9100,
    liquidationThreshold: 9300,
    liquidationBonus: 10210,
  },
  '11': {
    label: 'USDe / USDC,USDT',
    collateralBitmap: '1073741824',
    collateralAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    borrowableBitmap: '264',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9300,
    liquidationBonus: 10200,
  },
  '12': {
    label: 'USDe,PT_USDe_31JUL2025 / USDe',
    collateralBitmap: '8797166764032',
    collateralAssets: [
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0x917459337CaAC939D41d7493B3999f571D20D667',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9400,
    liquidationThreshold: 9600,
    liquidationBonus: 10110,
  },
  '13': {
    label: 'PT_eUSDE_14AUG2025,eUSDe / USDC,USDT',
    collateralBitmap: '52776558133248',
    collateralAssets: [
      '0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617',
      '0x90D2af7d622ca3141efA4d8f1F24d86E5974Cc8F',
    ],
    borrowableBitmap: '264',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9100,
    liquidationThreshold: 9300,
    liquidationBonus: 10200,
  },
  '14': {
    label: 'PT_eUSDE_14AUG2025,eUSDe / USDe',
    collateralBitmap: '52776558133248',
    collateralAssets: [
      '0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617',
      '0x90D2af7d622ca3141efA4d8f1F24d86E5974Cc8F',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9400,
    liquidationThreshold: 9600,
    liquidationBonus: 10100,
  },
  '15': {
    label: 'eUSDe / USDC,USDT',
    collateralBitmap: '35184372088832',
    collateralAssets: ['0x90D2af7d622ca3141efA4d8f1F24d86E5974Cc8F'],
    borrowableBitmap: '264',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9300,
    liquidationBonus: 10200,
  },
  '16': {
    label: 'FBTC / WBTC',
    collateralBitmap: '70368744177664',
    collateralAssets: ['0xC96dE26018A54D51c097160568752c4E3BD6C364'],
    borrowableBitmap: '4',
    borrowableAssets: ['0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8400,
    liquidationThreshold: 8600,
    liquidationBonus: 10300,
  },
  '17': {
    label: 'sUSDe,PT_sUSDE_31JUL2025,PT_sUSDE_25SEP2025 / USDC,USDT,USDe,USDtb',
    collateralBitmap: '283678294933504',
    collateralAssets: [
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
      '0x3b3fB9C57858EF816833dC91565EFcd85D96f634',
      '0x9F56094C450763769BA0EA9Fe2876070c0fD5F77',
    ],
    borrowableBitmap: '4399120253192',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10310,
  },
  '18': {
    label: 'PT_sUSDE_25SEP2025 / USDe',
    collateralBitmap: '281474976710656',
    collateralAssets: ['0x9F56094C450763769BA0EA9Fe2876070c0fD5F77'],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9200,
    liquidationThreshold: 9400,
    liquidationBonus: 10110,
  },
  '19': {
    label: 'USDe,PT_USDe_31JUL2025,PT_eUSDE_14AUG2025,PT_USDe_25SEP2025 / USDC,USDT,USDe',
    collateralBitmap: '589339306229760',
    collateralAssets: [
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0x917459337CaAC939D41d7493B3999f571D20D667',
      '0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617',
      '0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a',
    ],
    borrowableBitmap: '1073742088',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9100,
    liquidationThreshold: 9300,
    liquidationBonus: 10200,
  },
  '20': {
    label: 'USDe,PT_USDe_31JUL2025,PT_eUSDE_14AUG2025,PT_USDe_25SEP2025 / USDe',
    collateralBitmap: '589339306229760',
    collateralAssets: [
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0x917459337CaAC939D41d7493B3999f571D20D667',
      '0x14Bdc3A3AE09f5518b923b69489CBcAfB238e617',
      '0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9400,
    liquidationThreshold: 9600,
    liquidationBonus: 10110,
  },
  '21': {
    label: 'tETH / USDC,USDT',
    collateralBitmap: '1125899906842624',
    collateralAssets: ['0xD11c452fc99cF405034ee446803b6F6c1F6d5ED8'],
    borrowableBitmap: '264',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7200,
    liquidationThreshold: 7500,
    liquidationBonus: 10750,
  },
  '22': {
    label: 'ezETH / wstETH',
    collateralBitmap: '2251799813685248',
    collateralAssets: ['0xbf5495Efe5DB9ce00f80364C8B423567e58d2110'],
    borrowableBitmap: '2',
    borrowableAssets: ['0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '23': {
    label: 'ezETH / USDC,USDT',
    collateralBitmap: '2251799813685248',
    collateralAssets: ['0xbf5495Efe5DB9ce00f80364C8B423567e58d2110'],
    borrowableBitmap: '264',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 7500,
    liquidationThreshold: 7800,
    liquidationBonus: 10750,
  },
  '24': {
    label: 'sUSDe,PT_sUSDE_25SEP2025,PT_sUSDE_27NOV2025 / USDC,USDT,USDe,USDtb',
    collateralBitmap: '9288678526418944',
    collateralAssets: [
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
      '0x9F56094C450763769BA0EA9Fe2876070c0fD5F77',
      '0xe6A934089BBEe34F832060CE98848359883749B3',
    ],
    borrowableBitmap: '4399120253192',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10310,
  },
  '25': {
    label: 'PT_sUSDE_25SEP2025,PT_sUSDE_27NOV2025 / USDe',
    collateralBitmap: '9288674231451648',
    collateralAssets: [
      '0x9F56094C450763769BA0EA9Fe2876070c0fD5F77',
      '0xe6A934089BBEe34F832060CE98848359883749B3',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9200,
    liquidationThreshold: 9400,
    liquidationBonus: 10110,
  },
  '26': {
    label: 'weETH / WETH,wstETH',
    collateralBitmap: '268435456',
    collateralAssets: ['0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee'],
    borrowableBitmap: '3',
    borrowableAssets: [
      '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
      '0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9300,
    liquidationThreshold: 9500,
    liquidationBonus: 10100,
  },
  '27': {
    label: 'PT_USDe_25SEP2025,PT_USDe_27NOV2025 / USDC,USDT,USDe,USDtb',
    collateralBitmap: '18577348462903296',
    collateralAssets: [
      '0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a',
      '0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7',
    ],
    borrowableBitmap: '4399120253192',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9100,
    liquidationThreshold: 9300,
    liquidationBonus: 10200,
  },
  '28': {
    label: 'PT_USDe_25SEP2025,PT_USDe_27NOV2025 / USDe',
    collateralBitmap: '18577348462903296',
    collateralAssets: [
      '0xBC6736d346a5eBC0dEbc997397912CD9b8FAe10a',
      '0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9400,
    liquidationThreshold: 9600,
    liquidationBonus: 10100,
  },
  '29': {
    label: 'USDe,PT_USDe_27NOV2025,PT_USDe_5FEB2026 / USDC,USDT,USDe,USDtb',
    collateralBitmap: '54043196602187776',
    collateralAssets: [
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7',
      '0x1F84a51296691320478c98b8d77f2Bbd17D34350',
    ],
    borrowableBitmap: '4399120253192',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9100,
    liquidationThreshold: 9300,
    liquidationBonus: 10200,
  },
  '30': {
    label: 'USDe,PT_USDe_27NOV2025,PT_USDe_5FEB2026 / USDe',
    collateralBitmap: '54043196602187776',
    collateralAssets: [
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0x62C6E813b9589C3631Ba0Cdb013acdB8544038B7',
      '0x1F84a51296691320478c98b8d77f2Bbd17D34350',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9400,
    liquidationThreshold: 9600,
    liquidationBonus: 10100,
  },
  '31': {
    label: 'sUSDe,PT_sUSDE_27NOV2025,PT_sUSDE_5FEB2026 / USDC,USDT,USDe,USDtb',
    collateralBitmap: '81064797587636224',
    collateralAssets: [
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
      '0xe6A934089BBEe34F832060CE98848359883749B3',
      '0xE8483517077afa11A9B07f849cee2552f040d7b2',
    ],
    borrowableBitmap: '4399120253192',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10300,
  },
  '32': {
    label: 'sUSDe,PT_sUSDE_27NOV2025,PT_sUSDE_5FEB2026 / USDe',
    collateralBitmap: '81064797587636224',
    collateralAssets: [
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
      '0xe6A934089BBEe34F832060CE98848359883749B3',
      '0xE8483517077afa11A9B07f849cee2552f040d7b2',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9200,
    liquidationThreshold: 9400,
    liquidationBonus: 10200,
  },
  '33': {
    label: 'syrupUSDT / USDT,GHO',
    collateralBitmap: '288230376151711744',
    collateralAssets: ['0x356B8d89c1e1239Cbbb9dE4815c39A1474d5BA7D'],
    borrowableBitmap: '1048832',
    borrowableAssets: [
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x40D16FC0246aD3160Ccc09B8D0D3A2cD28aE6C2f',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10400,
  },
  '34': {
    label: 'USDe,PT_USDe_5FEB2026,PT_USDe_7MAY2026 / USDC,USDT,USDe,USDtb',
    collateralBitmap: '1188950302699552768',
    collateralAssets: [
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0x1F84a51296691320478c98b8d77f2Bbd17D34350',
      '0xAeBf0Bb9f57E89260d57f31AF34eB58657d96Ce0',
    ],
    borrowableBitmap: '4399120253192',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8900,
    liquidationThreshold: 9100,
    liquidationBonus: 10410,
  },
  '35': {
    label: 'USDe,PT_USDe_5FEB2026,PT_USDe_7MAY2026 / USDe',
    collateralBitmap: '1188950302699552768',
    collateralAssets: [
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0x1F84a51296691320478c98b8d77f2Bbd17D34350',
      '0xAeBf0Bb9f57E89260d57f31AF34eB58657d96Ce0',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8990,
    liquidationThreshold: 9190,
    liquidationBonus: 10310,
  },
  '36': {
    label: 'sUSDe,PT_sUSDE_5FEB2026,PT_sUSDE_7MAY2026 / USDC,USDT,USDe,USDtb',
    collateralBitmap: '2377900607546589184',
    collateralAssets: [
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
      '0xE8483517077afa11A9B07f849cee2552f040d7b2',
      '0x3de0ff76E8b528C092d47b9DaC775931cef80F49',
    ],
    borrowableBitmap: '4399120253192',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
      '0xC139190F447e929f090Edeb554D95AbB8b18aC1C',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8820,
    liquidationThreshold: 9020,
    liquidationBonus: 10510,
  },
  '37': {
    label: 'sUSDe,PT_sUSDE_5FEB2026,PT_sUSDE_7MAY2026 / USDe',
    collateralBitmap: '2377900607546589184',
    collateralAssets: [
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
      '0xE8483517077afa11A9B07f849cee2552f040d7b2',
      '0x3de0ff76E8b528C092d47b9DaC775931cef80F49',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 8900,
    liquidationThreshold: 9100,
    liquidationBonus: 10410,
  },
  '38': {
    label: 'sUSDe,PT_srUSDe_2APR2026 / USDC,USDT,USDe',
    collateralBitmap: '4611686022722355200',
    collateralAssets: [
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
      '0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375',
    ],
    borrowableBitmap: '1073742088',
    borrowableAssets: [
      '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
      '0xdAC17F958D2ee523a2206206994597C13D831ec7',
      '0x4c9EDD5852cd905f086C759E8383e09bff1E68B3',
    ],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9000,
    liquidationThreshold: 9200,
    liquidationBonus: 10420,
  },
  '39': {
    label: 'sUSDe,PT_srUSDe_2APR2026 / USDe',
    collateralBitmap: '4611686022722355200',
    collateralAssets: [
      '0x9D39A5DE30e57443BfF2A8307A4256c8797A3497',
      '0x9Bf45ab47747F4B4dD09B3C2c73953484b4eB375',
    ],
    borrowableBitmap: '1073741824',
    borrowableAssets: ['0x4c9EDD5852cd905f086C759E8383e09bff1E68B3'],
    ltvzeroBitmap: '0',
    ltvzeroAssets: [],
    ltv: 9200,
    liquidationThreshold: 9400,
    liquidationBonus: 10220,
  },
} as const;
export const EXTERNAL_LIBRARIES = {
  FLASHLOAN_LOGIC: '0xE66AdcF153d0bD67a74e5d23e23F90b4011024EC',
  BORROW_LOGIC: '0x1Fb8f7C906cddD28B42ae6Eb76abC04A91188635',
  LIQUIDATION_LOGIC: '0x8dc095F287dBEBD9e15f75BB3DfBF18389BB8104',
  POOL_LOGIC: '0x25Ed699a052B820d772765E26Ed4dD9f0A26F3E5',
  SUPPLY_LOGIC: '0x33654b16A4De97bCE05d7dD06803Bf1066f3123C',
} as const;
